export function BoldIcon(): JSX.Element {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00447 16.5929C10.3405 16.5929 12.4093 14.871 12.4093 12.1211C12.4093 10.0523 10.8505 8.50469 8.72792 8.34153V8.25441C9.5408 8.13202 10.2832 7.72315 10.8211 7.10155C11.3591 6.47996 11.6571 5.68657 11.6616 4.86454C11.6616 2.47262 9.82091 0.967773 6.88725 0.967773H0.0869141V16.5929H7.00447ZM3.35798 3.40404H6.04453C7.56997 3.40404 8.44754 4.11845 8.44754 5.37461C8.44754 6.6957 7.45117 7.46555 5.70713 7.46555H3.35798V3.40246V3.40404ZM3.35798 14.1566V9.61986H6.09839C8.02618 9.61986 9.07641 10.3992 9.07641 11.8613C9.07641 13.3551 8.05786 14.1566 6.17442 14.1566H3.3564H3.35798Z"
        fill="currentColor"
      />
    </svg>
  );
}
